import { httpClient } from 'shared/api/http-client'
import { LoginFormInterface } from '../types/post-login-interface'
import { LOGIN_API } from './constants'

export function login({ rememberMe = false, ...body }: LoginFormInterface) {
  return httpClient.post<{ redirect: string }>(LOGIN_API, {
    ...body,
    _remember_me: rememberMe,
  })
}
